export default "__VITE_ASSET__COmrN7ok__"